<ng-container *ngIf="isLoading">
  <div class="loading-box">
    <mat-progress-spinner
      class="loading"
      [mode]="isLoading ? 'indeterminate' : 'determinate'"
      [strokeWidth]="strokeWidth"
      [diameter]="width"
    >
    </mat-progress-spinner>
  </div>
</ng-container>
